module.exports = __webpack_public_path__ + "assets/img/wash.b1d2c1b9.png";